import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Send, FileText, History, Settings, ClipboardList } from 'lucide-react';
import Notices from './Notices';
import SendNotification from '../components/notifications/SendNotification';
import NotificationTemplates from '../components/notifications/NotificationTemplates';
import NotificationHistory from '../components/notifications/NotificationHistory';
import NotificationSettings from '../components/notifications/NotificationSettings';

const tabs = [
  {
    path: 'notices',
    label: 'Notices',
    icon: ClipboardList,
    description: 'Create and manage school announcements'
  },
  {
    path: 'send',
    label: 'Send Notification',
    icon: Send,
    description: 'Send notifications to students and parents'
  },
  {
    path: 'templates',
    label: 'Templates',
    icon: FileText,
    description: 'Manage notification templates'
  },
  {
    path: 'history',
    label: 'History',
    icon: History,
    description: 'View sent notifications'
  },
  {
    path: 'settings',
    label: 'Settings',
    icon: Settings,
    description: 'Configure notification settings'
  }
];

const NotificationManagement: React.FC = () => {
  const location = useLocation();
  const current = tabs.find(tab => location.pathname.endsWith(`/notifications/${tab.path}`)) || tabs[0];
  const Icon = current.icon;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center space-x-3">
        <div className="w-8 h-8 bg-[#e2916d] rounded-lg flex items-center justify-center">
          <Icon className="w-5 h-5 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-[#f3ede2]">{current.label}</h1>
          <p className="text-[#b9ad9b] mt-1">{current.description}</p>
        </div>
      </div>

      <Routes>
        <Route index element={<Navigate to="notices" replace />} />
        <Route path="notices" element={<Notices />} />
        <Route path="send" element={<SendNotification />} />
        <Route path="templates" element={<NotificationTemplates />} />
        <Route path="history" element={<NotificationHistory />} />
        <Route path="settings" element={<NotificationSettings />} />
        <Route path="*" element={<Navigate to="notices" replace />} />
      </Routes>
    </div>
  );
};

export default NotificationManagement;
